import styled from '@emotion/styled';
import { ListBody } from '@shared/ui/index';

export const SListBody = styled(ListBody)`
    display: flex;
    flex-direction: row;
`;